var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoOffBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 1L25 1 25 25 1 25z",
    transform: "translate(-284 -973) translate(24 230) translate(241 724) translate(19 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343A40",
    fillRule: "nonzero",
    d: "M18 10.2l5.213-3.65c.153-.107.353-.12.518-.034.166.086.269.257.269.444v12.08c0 .187-.103.358-.269.444-.165.086-.365.073-.518-.034L18 15.8V20c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V6c0-.552.448-1 1-1h14c.552 0 1 .448 1 1v4.2zm0 3.159l4 2.8V9.84l-4 2.8v.719zM4 7v12h12V7H4z",
    transform: "translate(-284 -973) translate(24 230) translate(241 724) translate(19 19)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#343A40",
    strokeWidth: 2,
    d: "M1 3L20 22",
    transform: "translate(-284 -973) translate(24 230) translate(241 724) translate(19 19)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoOffBlack);
export default __webpack_public_path__ + "static/media/ic-video-off-black.b8553c3e.svg";
export { ForwardRef as ReactComponent };